module.exports = __webpack_public_path__ + "assets/img/car2.b01ec3fe.png";